var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaobangceritage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    zoomAndPan: "magnify",
    viewBox: "0 0 90 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "917679eb1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.453125 0 L 88.546875 0 L 88.546875 29.03125 L 1.453125 29.03125 Z M 1.453125 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "176202fa03"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 20 L 17 20 L 17 23.40625 L 13 23.40625 Z M 13 20 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "942038eb2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 11 L 25.535156 11 L 25.535156 15 L 22 15 Z M 22 11 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc75126b13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.113281 14 L 11 14 L 11 18 L 8.113281 18 Z M 8.113281 14 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1b78e557b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 12 L 25.535156 12 L 25.535156 18 L 19 18 Z M 19 12 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fbfb3cd923"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.113281 11 L 14 11 L 14 17 L 8.113281 17 Z M 8.113281 11 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aae5b2c84c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 17 L 20 17 L 20 23.40625 L 14 23.40625 Z M 14 17 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "a25d6bf980"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#917679eb1c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1.453125 0 L 88.546875 0 L 88.546875 29.03125 L 1.453125 29.03125 Z M 1.453125 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ede8d1",
      fillOpacity: 1
    },
    d: "M 1.453125 0 L 88.546875 0 L 88.546875 29.03125 L 1.453125 29.03125 Z M 1.453125 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 12.152344 11.324219 L 13.453125 10.023438 L 12.296875 8.867188 C 12.175781 8.75 11.980469 8.75 11.859375 8.867188 L 10.996094 9.734375 C 10.875 9.851562 10.875 10.050781 10.996094 10.167969 Z M 12.152344 11.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 14.316406 13.492188 L 15.617188 12.191406 L 18.972656 15.546875 L 17.671875 16.847656 Z M 14.316406 13.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 21.140625 17.710938 L 19.839844 19.011719 L 20.988281 20.164062 C 21.109375 20.285156 21.304688 20.285156 21.425781 20.164062 L 22.289062 19.296875 C 22.410156 19.179688 22.410156 18.984375 22.289062 18.863281 Z M 21.140625 17.710938 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#176202fa03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 13.757812 21.625 C 13.636719 21.742188 13.636719 21.941406 13.757812 22.058594 L 14.621094 22.925781 C 14.742188 23.042969 14.9375 23.042969 15.058594 22.925781 L 16.210938 21.773438 L 14.910156 20.472656 Z M 13.757812 21.625 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 17.082031 18.304688 L 20.433594 14.949219 L 21.738281 16.25 L 18.382812 19.605469 Z M 17.082031 18.304688 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#942038eb2c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 25.050781 12.929688 C 25.171875 12.808594 25.171875 12.613281 25.050781 12.496094 L 24.1875 11.628906 C 24.066406 11.507812 23.871094 11.507812 23.75 11.628906 L 22.601562 12.78125 L 23.902344 14.082031 Z M 25.050781 12.929688 "
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#bc75126b13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 8.234375 16.101562 C 8.113281 16.222656 8.113281 16.417969 8.234375 16.539062 L 9.097656 17.402344 C 9.21875 17.523438 9.414062 17.523438 9.535156 17.402344 L 10.6875 16.253906 L 9.386719 14.953125 Z M 8.234375 16.101562 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 11.558594 12.78125 L 14.910156 9.425781 L 16.210938 10.730469 L 12.859375 14.082031 Z M 11.558594 12.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 19.53125 7.40625 C 19.648438 7.289062 19.648438 7.09375 19.53125 6.972656 L 18.664062 6.109375 C 18.542969 5.988281 18.347656 5.988281 18.230469 6.109375 L 17.078125 7.261719 L 18.378906 8.5625 Z M 19.53125 7.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 17.671875 11.324219 L 18.972656 10.023438 L 15.058594 6.109375 C 14.9375 5.988281 14.742188 5.988281 14.621094 6.109375 L 13.757812 6.972656 C 13.636719 7.09375 13.636719 7.289062 13.757812 7.40625 Z M 17.671875 11.324219 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#b1b78e557b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 21.136719 12.1875 L 19.839844 13.492188 L 23.75 17.402344 C 23.871094 17.523438 24.066406 17.523438 24.1875 17.402344 L 25.050781 16.539062 C 25.171875 16.417969 25.171875 16.222656 25.050781 16.101562 Z M 21.136719 12.1875 "
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#fbfb3cd923)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 12.148438 16.84375 L 13.449219 15.542969 L 9.535156 11.628906 C 9.414062 11.507812 9.21875 11.507812 9.097656 11.628906 L 8.234375 12.496094 C 8.113281 12.613281 8.113281 12.808594 8.234375 12.929688 Z M 12.148438 16.84375 "
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#aae5b2c84c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 15.617188 17.710938 L 14.316406 19.011719 L 18.230469 22.925781 C 18.347656 23.042969 18.542969 23.042969 18.664062 22.925781 L 19.53125 22.058594 C 19.648438 21.941406 19.648438 21.742188 19.53125 21.625 Z M 15.617188 17.710938 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 14.910156 14.953125 L 10.996094 18.863281 C 10.875 18.984375 10.875 19.179688 10.996094 19.296875 L 11.859375 20.164062 C 11.980469 20.285156 12.175781 20.285156 12.296875 20.164062 L 16.210938 16.253906 Z M 14.910156 14.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4f1e0c",
      fillOpacity: 1
    },
    d: "M 18.378906 14.082031 L 22.289062 10.167969 C 22.410156 10.050781 22.410156 9.851562 22.289062 9.734375 L 21.425781 8.867188 C 21.304688 8.75 21.109375 8.75 20.988281 8.867188 L 17.078125 12.78125 Z M 18.378906 14.082031 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.50305, 12.651652)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.34375 -0.59375 C 6.15625 -0.445312 5.863281 -0.296875 5.46875 -0.140625 C 5.070312 0.00390625 4.632812 0.078125 4.15625 0.078125 C 3.40625 0.078125 2.753906 -0.0820312 2.203125 -0.40625 C 1.648438 -0.738281 1.222656 -1.179688 0.921875 -1.734375 C 0.628906 -2.285156 0.484375 -2.890625 0.484375 -3.546875 C 0.484375 -4.273438 0.628906 -4.921875 0.921875 -5.484375 C 1.222656 -6.054688 1.632812 -6.5 2.15625 -6.8125 C 2.6875 -7.125 3.300781 -7.28125 4 -7.28125 C 4.4375 -7.28125 4.835938 -7.222656 5.203125 -7.109375 C 5.578125 -6.992188 5.90625 -6.847656 6.1875 -6.671875 L 5.640625 -5.328125 C 5.117188 -5.722656 4.585938 -5.921875 4.046875 -5.921875 C 3.679688 -5.921875 3.335938 -5.816406 3.015625 -5.609375 C 2.691406 -5.410156 2.4375 -5.132812 2.25 -4.78125 C 2.0625 -4.4375 1.96875 -4.050781 1.96875 -3.625 C 1.96875 -3.15625 2.054688 -2.742188 2.234375 -2.390625 C 2.410156 -2.046875 2.660156 -1.773438 2.984375 -1.578125 C 3.316406 -1.390625 3.703125 -1.296875 4.140625 -1.296875 C 4.484375 -1.296875 4.796875 -1.351562 5.078125 -1.46875 C 5.359375 -1.582031 5.582031 -1.71875 5.75 -1.875 Z M 6.34375 -0.59375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.332168, 12.651652)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.5 -1.40625 L 2.109375 -1.40625 L 1.515625 0 L 0.125 0 L 3.375 -7.5 L 3.453125 -7.5 L 6.703125 0 L 5.0625 0 Z M 4.03125 -2.609375 L 3.328125 -4.359375 L 2.609375 -2.609375 Z M 4.03125 -2.609375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.151482, 12.651652)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.484375 -3.59375 C 0.484375 -4.25 0.648438 -4.859375 0.984375 -5.421875 C 1.316406 -5.992188 1.765625 -6.445312 2.328125 -6.78125 C 2.890625 -7.113281 3.5 -7.28125 4.15625 -7.28125 C 4.820312 -7.28125 5.4375 -7.113281 6 -6.78125 C 6.5625 -6.445312 7.007812 -5.992188 7.34375 -5.421875 C 7.6875 -4.859375 7.859375 -4.25 7.859375 -3.59375 C 7.859375 -2.925781 7.6875 -2.3125 7.34375 -1.75 C 7.007812 -1.1875 6.5625 -0.738281 6 -0.40625 C 5.4375 -0.0820312 4.820312 0.078125 4.15625 0.078125 C 3.5 0.078125 2.890625 -0.0820312 2.328125 -0.40625 C 1.765625 -0.738281 1.316406 -1.1875 0.984375 -1.75 C 0.648438 -2.3125 0.484375 -2.925781 0.484375 -3.59375 Z M 1.953125 -3.59375 C 1.953125 -3.175781 2.050781 -2.789062 2.25 -2.4375 C 2.457031 -2.082031 2.726562 -1.800781 3.0625 -1.59375 C 3.40625 -1.394531 3.789062 -1.296875 4.21875 -1.296875 C 4.613281 -1.296875 4.976562 -1.394531 5.3125 -1.59375 C 5.644531 -1.800781 5.90625 -2.078125 6.09375 -2.421875 C 6.289062 -2.773438 6.390625 -3.164062 6.390625 -3.59375 C 6.390625 -4.019531 6.289062 -4.410156 6.09375 -4.765625 C 5.894531 -5.117188 5.628906 -5.398438 5.296875 -5.609375 C 4.960938 -5.816406 4.585938 -5.921875 4.171875 -5.921875 C 3.765625 -5.921875 3.390625 -5.816406 3.046875 -5.609375 C 2.710938 -5.398438 2.445312 -5.117188 2.25 -4.765625 C 2.050781 -4.410156 1.953125 -4.019531 1.953125 -3.59375 Z M 1.953125 -3.59375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.499262, 12.651652)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.640625 -3.796875 C 5.023438 -3.617188 5.320312 -3.390625 5.53125 -3.109375 C 5.738281 -2.828125 5.84375 -2.5 5.84375 -2.125 C 5.84375 -1.394531 5.601562 -0.859375 5.125 -0.515625 C 4.644531 -0.171875 4.046875 0 3.328125 0 L 0.9375 0 L 0.9375 -7.203125 L 3.046875 -7.203125 C 3.804688 -7.203125 4.40625 -7.046875 4.84375 -6.734375 C 5.28125 -6.429688 5.5 -5.984375 5.5 -5.390625 C 5.5 -5.035156 5.425781 -4.722656 5.28125 -4.453125 C 5.132812 -4.179688 4.921875 -3.960938 4.640625 -3.796875 Z M 2.34375 -4.265625 L 3.21875 -4.265625 C 3.476562 -4.265625 3.675781 -4.34375 3.8125 -4.5 C 3.957031 -4.65625 4.03125 -4.851562 4.03125 -5.09375 C 4.03125 -5.332031 3.945312 -5.515625 3.78125 -5.640625 C 3.625 -5.773438 3.398438 -5.84375 3.109375 -5.84375 L 2.34375 -5.84375 Z M 3.265625 -1.328125 C 3.597656 -1.328125 3.863281 -1.390625 4.0625 -1.515625 C 4.269531 -1.648438 4.375 -1.851562 4.375 -2.125 C 4.375 -2.632812 3.972656 -2.890625 3.171875 -2.890625 L 2.34375 -2.890625 L 2.34375 -1.328125 Z M 3.265625 -1.328125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.83848, 12.651652)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.5 -1.40625 L 2.109375 -1.40625 L 1.515625 0 L 0.125 0 L 3.375 -7.5 L 3.453125 -7.5 L 6.703125 0 L 5.0625 0 Z M 4.03125 -2.609375 L 3.328125 -4.359375 L 2.609375 -2.609375 Z M 4.03125 -2.609375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.657794, 12.651652)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.421875 -7.203125 L 7.421875 0.296875 L 7.390625 0.296875 L 2.34375 -4.265625 L 2.375 0 L 0.9375 0 L 0.9375 -7.5 L 0.984375 -7.5 L 6.03125 -2.875 L 6 -7.203125 Z M 7.421875 -7.203125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.015378, 12.651652)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.78125 -0.71875 C 6.664062 -0.601562 6.46875 -0.484375 6.1875 -0.359375 C 5.90625 -0.234375 5.59375 -0.128906 5.25 -0.046875 C 4.90625 0.0351562 4.59375 0.078125 4.3125 0.078125 C 3.550781 0.078125 2.878906 -0.0664062 2.296875 -0.359375 C 1.722656 -0.660156 1.273438 -1.070312 0.953125 -1.59375 C 0.640625 -2.125 0.484375 -2.726562 0.484375 -3.40625 C 0.484375 -4.238281 0.648438 -4.945312 0.984375 -5.53125 C 1.316406 -6.125 1.765625 -6.5625 2.328125 -6.84375 C 2.890625 -7.132812 3.507812 -7.28125 4.1875 -7.28125 C 4.625 -7.28125 5.035156 -7.234375 5.421875 -7.140625 C 5.804688 -7.046875 6.148438 -6.921875 6.453125 -6.765625 L 5.984375 -5.4375 C 5.796875 -5.539062 5.535156 -5.632812 5.203125 -5.71875 C 4.878906 -5.8125 4.601562 -5.859375 4.375 -5.859375 C 3.59375 -5.859375 2.992188 -5.660156 2.578125 -5.265625 C 2.160156 -4.878906 1.953125 -4.300781 1.953125 -3.53125 C 1.953125 -3.082031 2.050781 -2.691406 2.25 -2.359375 C 2.457031 -2.035156 2.742188 -1.785156 3.109375 -1.609375 C 3.472656 -1.429688 3.882812 -1.34375 4.34375 -1.34375 C 4.789062 -1.34375 5.125 -1.40625 5.34375 -1.53125 L 5.34375 -2.40625 L 4.09375 -2.40625 L 4.09375 -3.765625 L 6.78125 -3.765625 Z M 6.78125 -0.71875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.031425, 22.208343)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.34375 -0.59375 C 6.15625 -0.445312 5.863281 -0.296875 5.46875 -0.140625 C 5.070312 0.00390625 4.632812 0.078125 4.15625 0.078125 C 3.40625 0.078125 2.753906 -0.0820312 2.203125 -0.40625 C 1.648438 -0.738281 1.222656 -1.179688 0.921875 -1.734375 C 0.628906 -2.285156 0.484375 -2.890625 0.484375 -3.546875 C 0.484375 -4.273438 0.628906 -4.921875 0.921875 -5.484375 C 1.222656 -6.054688 1.632812 -6.5 2.15625 -6.8125 C 2.6875 -7.125 3.300781 -7.28125 4 -7.28125 C 4.4375 -7.28125 4.835938 -7.222656 5.203125 -7.109375 C 5.578125 -6.992188 5.90625 -6.847656 6.1875 -6.671875 L 5.640625 -5.328125 C 5.117188 -5.722656 4.585938 -5.921875 4.046875 -5.921875 C 3.679688 -5.921875 3.335938 -5.816406 3.015625 -5.609375 C 2.691406 -5.410156 2.4375 -5.132812 2.25 -4.78125 C 2.0625 -4.4375 1.96875 -4.050781 1.96875 -3.625 C 1.96875 -3.15625 2.054688 -2.742188 2.234375 -2.390625 C 2.410156 -2.046875 2.660156 -1.773438 2.984375 -1.578125 C 3.316406 -1.390625 3.703125 -1.296875 4.140625 -1.296875 C 4.484375 -1.296875 4.796875 -1.351562 5.078125 -1.46875 C 5.359375 -1.582031 5.582031 -1.71875 5.75 -1.875 Z M 6.34375 -0.59375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.860543, 22.208343)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.84375 -7.203125 L 5.84375 -5.84375 L 2.34375 -5.84375 L 2.34375 -4.296875 L 5.453125 -4.296875 L 5.453125 -2.921875 L 2.34375 -2.921875 L 2.34375 -1.375 L 5.984375 -1.375 L 5.984375 0 L 0.9375 0 L 0.9375 -7.203125 Z M 5.84375 -7.203125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.385921, 22.208343)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.8125 0 L 3.296875 -2.296875 L 2.34375 -2.296875 L 2.34375 0 L 0.9375 0 L 0.9375 -7.203125 L 3.109375 -7.203125 C 4.003906 -7.203125 4.695312 -6.984375 5.1875 -6.546875 C 5.6875 -6.117188 5.9375 -5.53125 5.9375 -4.78125 C 5.9375 -4.332031 5.84375 -3.914062 5.65625 -3.53125 C 5.46875 -3.144531 5.179688 -2.835938 4.796875 -2.609375 L 6.46875 0 Z M 2.34375 -3.65625 L 3.359375 -3.65625 C 3.742188 -3.65625 4.023438 -3.769531 4.203125 -4 C 4.378906 -4.226562 4.46875 -4.472656 4.46875 -4.734375 C 4.46875 -4.992188 4.390625 -5.242188 4.234375 -5.484375 C 4.085938 -5.722656 3.800781 -5.84375 3.375 -5.84375 L 2.34375 -5.84375 Z M 2.34375 -3.65625 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.107264, 22.208343)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.34375 -7.203125 L 2.34375 0 L 0.9375 0 L 0.9375 -7.203125 Z M 2.34375 -7.203125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.38955, 22.208343)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.296875 -7.203125 L 5.296875 -5.84375 L 3.546875 -5.84375 L 3.546875 0 L 2.125 0 L 2.125 -5.84375 L 0.4375 -5.84375 L 0.4375 -7.203125 Z M 5.296875 -7.203125 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.131105, 22.208343)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.5 -1.40625 L 2.109375 -1.40625 L 1.515625 0 L 0.125 0 L 3.375 -7.5 L 3.453125 -7.5 L 6.703125 0 L 5.0625 0 Z M 4.03125 -2.609375 L 3.328125 -4.359375 L 2.609375 -2.609375 Z M 4.03125 -2.609375 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.950418, 22.208343)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.78125 -0.71875 C 6.664062 -0.601562 6.46875 -0.484375 6.1875 -0.359375 C 5.90625 -0.234375 5.59375 -0.128906 5.25 -0.046875 C 4.90625 0.0351562 4.59375 0.078125 4.3125 0.078125 C 3.550781 0.078125 2.878906 -0.0664062 2.296875 -0.359375 C 1.722656 -0.660156 1.273438 -1.070312 0.953125 -1.59375 C 0.640625 -2.125 0.484375 -2.726562 0.484375 -3.40625 C 0.484375 -4.238281 0.648438 -4.945312 0.984375 -5.53125 C 1.316406 -6.125 1.765625 -6.5625 2.328125 -6.84375 C 2.890625 -7.132812 3.507812 -7.28125 4.1875 -7.28125 C 4.625 -7.28125 5.035156 -7.234375 5.421875 -7.140625 C 5.804688 -7.046875 6.148438 -6.921875 6.453125 -6.765625 L 5.984375 -5.4375 C 5.796875 -5.539062 5.535156 -5.632812 5.203125 -5.71875 C 4.878906 -5.8125 4.601562 -5.859375 4.375 -5.859375 C 3.59375 -5.859375 2.992188 -5.660156 2.578125 -5.265625 C 2.160156 -4.878906 1.953125 -4.300781 1.953125 -3.53125 C 1.953125 -3.082031 2.050781 -2.691406 2.25 -2.359375 C 2.457031 -2.035156 2.742188 -1.785156 3.109375 -1.609375 C 3.472656 -1.429688 3.882812 -1.34375 4.34375 -1.34375 C 4.789062 -1.34375 5.125 -1.40625 5.34375 -1.53125 L 5.34375 -2.40625 L 4.09375 -2.40625 L 4.09375 -3.765625 L 6.78125 -3.765625 Z M 6.78125 -0.71875 "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#4f1e0c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.416392, 22.208343)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.84375 -7.203125 L 5.84375 -5.84375 L 2.34375 -5.84375 L 2.34375 -4.296875 L 5.453125 -4.296875 L 5.453125 -2.921875 L 2.34375 -2.921875 L 2.34375 -1.375 L 5.984375 -1.375 L 5.984375 0 L 0.9375 0 L 0.9375 -7.203125 Z M 5.84375 -7.203125 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaobangceritage);
export default __webpack_public_path__ + "static/media/caobangceritage.c25da6b4ec203080167b4fdc8c0681c2.svg";
export { ForwardRef as ReactComponent };